import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_Transition, { name: "slide-fade" }, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref: "modal",
                        class: _normalizeClass(_ctx.modalClass),
                        style: _normalizeStyle(_ctx.modalStyle)
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 6)
                ]),
                _: 3
            })
        ]))
        : _createCommentVNode("", true);
}
